import { BankLink, BankLinkStatus } from '@orbis-systems/orbis-api-middleware';

export function filterActiveBankLinks(bankLinks: BankLink[] | undefined): BankLink[] {
    return bankLinks?.filter((link) => link.status !== BankLinkStatus.Canceled) ?? [];
}
